import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    passwordStrength: {
        height: '36px',
        paddingBottom: '8px',
    },
    passwordStrengthInfo: {
        margin: '8px 0 0',
    },
    passwordStrengthMeter: {
        position: 'relative',
        height: '3px',
        background: '#ddd',
        '&::before, &::after': {
            content: '""',
            boxSizing: 'content-box',
            height: 'inherit',
            background: 'transparent',
            border: 'solid 0 #fff',
            borderWidth: '0 5px 0 5px',
            display: 'block',
            position: 'absolute',
            width: '20%',
            zIndex: 10,
        },
        '&::before': {
            left: '20%',
        },
        '&::after': {
            left: '60%',
        },
    },
    passwordStrengthMeterFill: {
        background: 'transparent',
        height: 'inherit',
        position: 'absolute',
        width: 0,
        transition: 'width 0.5s ease-in-out, background 0.25s',
        '&[data-strength="0"]': {
            background: '#a03',
            width: 'calc(20% + 5px)',
        },
        '&[data-strength="1"]': {
            background: '#a03',
            width: 'calc(40% + 5px)',
        },
        '&[data-strength="2"]': {
            background: '#fc3',
            width: 'calc(60% + 5px)',
        },
        '&[data-strength="3"]': {
            background: '#2d98f3',
            width: 'calc(80% + 5px)',
        },
        '&[data-strength="4"]': {
            background: '#76c261',
            width: '100%',
        },
    },
});

const STRENGTH = {
    0: 'Too short',
    1: 'Weak',
    2: 'Fair',
    3: 'Good',
    4: 'Strong',
};

function getStrengthInfo(value = 0) {
    return STRENGTH[value] || STRENGTH[0];
}

const PasswordStrength = ({ classes, visible, score }) => {
    return (
        <div className={classes.passwordStrength}>
            {visible && (
                <React.Fragment>
                    <div className={classes.passwordStrengthMeter}>
                        <div
                            className={classes.passwordStrengthMeterFill}
                            data-strength={score}
                        />
                    </div>
                    <Typography
                        className={classes.passwordStrengthInfo}
                        color="textSecondary"
                    >
                        <strong>Password strength:</strong>{' '}
                        {getStrengthInfo(score)}
                    </Typography>
                </React.Fragment>
            )}
        </div>
    );
};

export default withStyles(styles)(PasswordStrength);
